import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useCraftsCart } from "@/context/CraftsCartContext";

export const BundleBanner = () => {
  const { add, setOpen } = useCraftsCart();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/crafts").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  if (items.length < 3) return null;

  const addAll = () => {
    items.forEach((c) => add(c));
    setOpen(true);
  };

  return (
    <div data-testid="bundle-banner"
      className="flex flex-col sm:flex-row items-center justify-between gap-4 border border-gold/30 bg-gold/[0.06] px-6 py-4">
      <p className="text-sm text-cream/85 text-center sm:text-left">
        <span className="text-gold font-medium">Get all three guides</span> and save 15% at checkout — the complete studio collection.
      </p>
      <button onClick={addAll} data-testid="bundle-add-all"
        className="shrink-0 inline-flex items-center gap-2 bg-gold text-cocoa px-6 py-2.5 text-[0.66rem] tracking-[0.18em] uppercase hover:bg-cream transition-colors">
        Add all three
      </button>
    </div>
  );
};

export default BundleBanner;
